import { object, string } from 'yup'

export interface OrganisationFormValues {
  name: string
  street: string
  zipCode: string
  city: string
}

export const organisationValidationSchema = object({
  name: string().required('Name ist erforderlich'),
  street: string().required('Straße ist erforderlich'),
  zipCode: string().required('PLZ ist erforderlich'),
  city: string().required('Stadt ist erforderlich'),
})
